export const SET_SCHEDULES = 'SET_SCHEDULES';

export function setSchedules(schedules) {
  return {
    type: SET_SCHEDULES,
    meta: { schedules }
  };
}
